import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "el-text__primary" }, " Favorites "),
  /*#__PURE__*/_createElementVNode("p", null, " Manage, customized and even share favorites within your organization. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        type: "flex",
        justify: "space-between",
        align: "middle"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: _ctx.favoritesResponse.rows,
        style: {"width":"100%"},
        border: "",
        stripe: ""
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "No Favorites Saved" })
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, columnIndex) => {
            return (_openBlock(), _createBlock(_component_el_table_column, {
              key: columnIndex,
              prop: column.prop,
              label: column.label
            }, {
              default: _withCtx((scope) => [
                (column.prop === 'created')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(scope.row[column.id]
                  ? new Date(scope.row[column.id]).toLocaleDateString('en-US')
                  : scope.row[column.id]), 1)
                    ], 64))
                  : (column.prop === 'favourite_name')
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 1,
                        type: "primary",
                        href: `/dashboards/${scope.row.view_name}?favorite=${scope.row.favourite_name}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row[column.prop]), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(scope.row[column.prop]), 1)
                      ], 64))
              ]),
              _: 2
            }, 1032, ["prop", "label"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _: 1
  }))
}